import { Injectable } from "@angular/core";
import { ClientStatus } from "app/server/enums/client-status.enum";
import { OfficeType } from "app/server/enums/office-type.enum";
import { UserRole } from "app/server/enums/user-role.enum";
import { EnumDisplayService } from "./enum-display.service";
import { ReportSubject } from "../../server/enums/report-subject.enum";
import { ReportEntryCategory } from "../../server/enums/report-entry-category.enum";

export interface EnumDropdownOption {
  value: string;
  display: string;
}

@Injectable({ providedIn: "root" })
export class EnumService {
  constructor(private enumDisplayService: EnumDisplayService) {}

  getEnumDropdownOptions(enumInstance: Record<string, string>): Array<{ value: string }> {
    return Object.values(enumInstance).map((value) => {
      return { value };
    });
  }

  get clientStatusDropdownOptions(): EnumDropdownOption[] {
    return Object.values(ClientStatus)
      .map((value) => {
        const display = this.enumDisplayService.getClientStatusDisplay(value);
        return { value, display };
      })
      .sort((a, b) => {
        if (a.display < b.display) {
          return -1;
        }
        if (a.display > b.display) {
          return 1;
        }
        return 0;
      });
  }

  get officeTypeDropdownOptions(): EnumDropdownOption[] {
    return Object.values(OfficeType).map((value) => {
      const display = this.enumDisplayService.getOfficeTypeDisplay(value);
      return { value, display };
    });
  }

  get userRoleDropdownOptions(): EnumDropdownOption[] {
    return Object.values(UserRole).map((value) => {
      const display = this.enumDisplayService.getUserRoleDisplay(value);
      return { value, display };
    });
  }

  get reportSubjectDropdownOptions(): EnumDropdownOption[] {
    return Object.values(ReportSubject).map((value) => {
      const display = this.enumDisplayService.getReportSubjectDisplay(value);
      return { value, display };
    });
  }

  reportEntryCategoryDropdownOptions(options: ReportEntryCategory[]): EnumDropdownOption[] {
    return options.map((value) => {
      const display = this.enumDisplayService.getReportEntryCategoryDisplay(value);
      return { value, display };
    });
  }
}
